import { Component, type ErrorInfo, type ReactNode } from "react";

type StructuredDiffErrorBoundaryState = {
  hasError: boolean;
};

export class StructuredDiffErrorBoundary extends Component<
  { children: ReactNode; onError?: () => void },
  StructuredDiffErrorBoundaryState
> {
  constructor(props: { children: ReactNode; onError?: () => void }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): StructuredDiffErrorBoundaryState {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[StructuredDiffViewer] render error:", error, errorInfo);
    this.props.onError?.();
  }

  override render() {
    if (this.state.hasError) {
      // onError コールバック経由でモーダルを閉じ、トーストを表示する。
      // ここでは何も描画しない（fallback UI なし）。
      return null;
    }
    return this.props.children;
  }
}
